import { render } from "./EmailCreateCampaign.vue?vue&type=template&id=5e2d7882"
import script from "./EmailCreateCampaign.vue?vue&type=script&lang=js"
export * from "./EmailCreateCampaign.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__